export const UPDATE_FLASH_MESSAGE = 'UPDATE_FLASH_MESSAGE';
export const RESET_FLASH_MESSAGE = 'RESET_FLASH_MESSAGE';
export const TOGGLE_DIALOG_MODAL = 'TOGGLE_DIALOG_MODAL';

// AUTH
export const AUTHENTICATION = 'AUTHENTICATION';
export const CURRICULUM = 'CURRICULUM';
export const EMAIL = 'EMAIL';
export const PARTICIPANTS = 'PARTICIPANTS';
export const EVENT_LOGS = 'EVENT_LOGS';
export const LANGUAGE = 'LANGUAGE';
export const LESSONS = 'LESSONS';
export const PRODUCT = 'PRODUCT';
export const PRODUCT_EVENT = 'PRODUCT_EVENT';
export const PERMISSION = 'PERMISSION';
export const PAYMENT = 'PAYMENT';
export const PROFILE = 'PROFILE';
export const RESPONSE = 'RESPONSE';
export const QUESTIONNAIRE = 'QUESTIONNAIRE';
export const SEO_CONTENT = 'SEO_CONTENT';
export const SIGNEDURL = 'SIGNEDURL';
export const ADD_CHAT = 'ADD_CHAT';
export const ADD_NEW_MESSAGE_CHAT = 'ADD_NEW_MESSAGE_CHAT';
export const UPDATE_CHAT = 'UPDATE_CHAT';
export const ADD_NEW_MESSAGES = 'ADD_NEW_MESSAGES';
export const CLEAR_CHAT = 'CLEAR_CHAT';
export const DELETE_CHAT_MESSAGE = 'DELETE_CHAT_MESSAGE';
export const EDIT_CHAT_MESSAGE = 'EDIT_CHAT_MESSAGE';
export const USERS = 'USERS';
export const TOPIC = 'TOPIC';
export const SUBJECT = 'SUBJECT';
